export default __webpack_public_path__ + "static/media/snowgenesis-hero4.cbef22dd.png";